import React, { useContext, useState, Suspense } from "react";
import { PeFilterContext, ReCompaniesMaxDealOptions, ReCompaniesMinDealOptions } from "../../Contexts/PeFilterContext";
import { TableHeaderContext } from "../../Contexts/TableHeaderContext";
import SectorFilter from "../../Components/RefineSearchComponents/FundSector";
import TypeFilter from "../../Components/RefineSearchComponents/ReTypeFilter";
import RegionFilter from "../../Components/RefineSearchComponents/RegionFilter";
import CityFilter from "../../Components/RefineSearchComponents/CityFilter";
import DealRangeFilter from "../../Components/RefineSearchComponents/DealRangeFilter";
import { useLocation, useMatch, useNavigate } from "react-router";
import routePathSegments, { routeNames } from "../../routeSegments";
import { useEffect } from "react";
import axios from "axios";
import { filterLocationUrl, filterSectorByIndutry } from "../../Config/config";
import { UserContext } from "../../Contexts/UserContext";
import AcquirerDealRangeFilter from "../RefineSearchComponents/AcquirerDealRangeFilter";
import Constants from "../../Constants";
import ToggleButton from "../RefineSearchComponents/ToggleAndOrSwitch";
import LAdvisor from '../RefineSearchComponents/lAdvisor';
import TAdvisor from '../RefineSearchComponents/tAdvisor';
import TargetCompany from '../RefineSearchComponents/TargetCompany';
import Acquirers from "../RefineSearchComponents/Acquirers";
import { IoMdArrowDropdown, IoMdArrowDropright } from "react-icons/io";
import Subsectors from "../RefineSearchComponents/Subsectors";
const InvestorDealRangeFilter = React.lazy(() => import("../RefineSearchComponents/InvestorDealRangeFilter"));

/**
 * The function `ReOthermaRefineSearch` is a React component that renders a form for refining search
 * filters in a specific context.
 * @returns a JSX element.
 */

export default function ReOthermaRefineSearch({ customPathname, menu, generalPathname }) {
    const {
        setSectors,dbDropdown , setDbDropdown ,SubSectorOptions, setSubSectorOptions,
        onErrorHandler,SwitchState,setSwitchState,dropdown,
        AcquirersOptions , setAcquirersOptions ,
        lAdvisorsOptions,setlAdvisorsOptions,tAdvisorsOptions , settAdvisorsOptions , TargetCompanyOptions , setTargetCompanyOptions ,
        refineSearchFilters,
        setMonthPickerValue,
        setrefineSearchFilters } = useContext(PeFilterContext);
    const { setSelectedPage } = useContext(TableHeaderContext);
    const [select, setSelected] = useState(0);
    const navigate = useNavigate();
    // const [savedFilters, setSavedFilters] = useState(state?.filters)
    const { getToken } = useContext(UserContext);
    const isMatch = useMatch({ path: routeNames.re_companies_re_investments })
    const isRematch = useMatch({ path: `${routePathSegments.re}/*` })
    const location = useLocation();
    const {pathname} = useLocation();
    const isFromGlobalSearch = ()=> refineSearchFilters[pathname]?.globalSearch?.length > 0 ? true : false
    const isFromSearchedList = ()=> refineSearchFilters[location?.state?.prevPath]?.globalSearch?.length > 0 ? true : false


    //local updated options
    const [SectorOptions, setSectorOptions] = useState([])
    const [TypeOption, setTypeOption] = useState([]);
    const [RegionOptions, setRegionOptions] = useState([])
    const [CityOptions, setCityOptions] = useState([])
    // const [SubSectorOptions, setSubSectorOptions] = useState([])
    // const [DealRange, setDealRange]                     = useState({ from: "", to: "" })
    const [MinDealRangeOptions, setMinDealRangeOptions] = useState([])
    const [MaxDealRangeOptions, setMaxDealRangeOptions] = useState([])
    const [CountryOptions, setCountryOptions] = useState([])



    const applyFilter = () => {
        const selectedFundSector = SectorOptions.filter(option => option.isChecked);
        const selectedRegion = RegionOptions?.filter(option => option.isChecked);
        const selectedCity = CityOptions?.filter(option => option.isChecked);
        const selectedType = TypeOption?.filter(option => option.isChecked);
        const minDealRange = MinDealRangeOptions?.filter(option => option.isChecked)?.at(0) ?? null;
        const maxDealRange = MaxDealRangeOptions?.filter(option => option.isChecked)?.at(0) ?? null;
        const selectedOperators = SwitchState;
        const selectedlAdvisors = lAdvisorsOptions?.filter(option => option.isChecked);
        const selectedtAdvisors = tAdvisorsOptions?.filter(option => option.isChecked);
        const selectedTargetCompany = TargetCompanyOptions?.filter(option => option.isChecked); 
        const selectedAcquirers = AcquirersOptions?.filter(option => option.isChecked); 
        const selectedSubsector = SubSectorOptions?.filter(option => option.isChecked);

        setrefineSearchFilters(prev => ({
            ...prev,
            [generalPathname]:{
                ...prev[generalPathname],
                fundSector: selectedFundSector,
                subSector: selectedSubsector,
                region: selectedRegion,
                city: selectedCity,
                type: selectedType,
                dealRange: minDealRange != null && maxDealRange != null ? [minDealRange, maxDealRange] : [],
            },
            [customPathname]: {
                ...prev[customPathname],

                deals_operator : selectedOperators,
                ladvisors: selectedlAdvisors,
                tadvisors: selectedtAdvisors,
                investor_id : selectedAcquirers ,
                target_company:selectedTargetCompany,
                // dealRange   : DealRange?.from !== "" && DealRange?.to !== "" ? [{ id: 0, name: DealRange?.from }, { id: 1, name: DealRange?.to }] : [],

            },
        }))
    }

    const resetFilter = () => {
        setrefineSearchFilters(prev => ({
            ...prev,
            [generalPathname]:{},
            [customPathname]: {}
        }))
        setlAdvisorsOptions([]);
        settAdvisorsOptions([]);
        setTargetCompanyOptions([]);
        setAcquirersOptions(AcquirersOptions.map(option => {
                if (option.isChecked) {
                    return { ...option, isChecked: false };
                }
                return option;
            })
        )
        setSubSectorOptions([]);
    }


    console.log('refineSearchFilters[refineSearchFilters]', refineSearchFilters[customPathname]);


    // Submitting Refine Search Form 

    const refineSearchFilter = (event) => {
        event.preventDefault();
        setrefineSearchFilters(prev => ({
            ...prev,
            [generalPathname]:{},
            [customPathname]: {globalSearch:[],
            }
        }))
        if(isFromGlobalSearch() || isFromSearchedList()){
            setMonthPickerValue(Constants.initialMonthRange)
        }
        setSelectedPage(1);
        applyFilter();
        setSelected(false)
        if (location.pathname != customPathname) {
            navigate(customPathname)
        }
    }


    const onResetClick = (event) => {
        event.preventDefault();
        setSelectedPage(1);
        // if (isMatch == null || isCompanyMatch != null) {
        //     navigate(routeNames.re_companies_re_investments);
        // }
        resetFilter()
        if (location.pathname != customPathname) {
            navigate(customPathname)
        }
    }

    const accordionClick = (val) => {
        if (val === select) {
            setSelected(0);
        } else {
            setSelected(val);
        }
    };

    const onRegionChange = (options) => {
        const ids = options.filter(industry => industry.isChecked)?.map(option => option.id);
        const selectedCountries = CountryOptions?.filter(option => option.isChecked)?.map(option => option.id);
        axios.post(filterLocationUrl, {
            country: selectedCountries,
            region: ids,
            state: [],
            city: [],

        }, {
            headers: {
                "Authorization": getToken()
            }
        }).then(response => {
            if (response.status === 200) {
                // setStateOptions(response.data.state)
                setCityOptions(response.data?.city)
            }
        }).catch(onErrorHandler)
    }

    useEffect(() => {
        const ids = refineSearchFilters[generalPathname]?.region?.map(value => value.id) ?? [];
        const cityIds = refineSearchFilters[generalPathname]?.city?.map(value => value.id) ?? [];
        axios.post(filterLocationUrl, {
            country: [],
            region: [],
            state: [],
            city: [],

        }, {
            headers: {
                "Authorization": getToken()
            }
        }).then(response => {
            if (response.status === 200) {
                setRegionOptions(response.data?.region?.map(option => ({ ...option, isChecked: ids.includes(option.id) })))
                setCityOptions(response.data.city?.map(option => ({ ...option, isChecked: cityIds.includes(option.id) })))
            }
        }).catch(onErrorHandler)
    }, [refineSearchFilters])

    const toggleSwitchState = () => {
        setSwitchState(prevState => prevState === "and" ? "or" : "and");
    };

    const handleDbToggle = () => {
        setDbDropdown(!dbDropdown);
    };

    // State for managing which filter section is active
    const [activeFilterSection, setActiveFilterSection] = useState("keyword");
    
    // State for managing which individual filter popup is open
    const [openFilterPopup, setOpenFilterPopup] = useState(null);

    // Helper functions to count applied filters for each section
    const getTargetFiltersCount = () => {
        let count = 0;
        if (RegionOptions?.length > 0 && RegionOptions.some(option => option.isChecked)) count++;
        if (CityOptions?.length > 0 && CityOptions.some(option => option.isChecked)) count++;
        if (TypeOption?.length > 0 && TypeOption.some(option => option.isChecked)) count++;
        return count;
    };

    const getDealFiltersCount = () => {
        let count = 0;
        if (MinDealRangeOptions?.length > 0 && MinDealRangeOptions.some(option => option.isChecked)) count++;
        if (SubSectorOptions?.length > 0 && SubSectorOptions.some(option => option.isChecked)) count++;
        return count;
    };

    const getKeywordFiltersCount = () => {
        let count = 0;
        if (AcquirersOptions?.length > 0 && AcquirersOptions.some(option => option.isChecked)) count++;
        if (TargetCompanyOptions?.length > 0 && TargetCompanyOptions.some(option => option.isChecked)) count++;
        if (lAdvisorsOptions?.length > 0 && lAdvisorsOptions.some(option => option.isChecked)) count++;
        if (tAdvisorsOptions?.length > 0 && tAdvisorsOptions.some(option => option.isChecked)) count++;
        return count;
    };

    useEffect(()=> {
        setrefineSearchFilters(prev => ({
            ...prev,
            [generalPathname]:{
                ...prev[generalPathname],
                fundSector: [],
                exitStatus:[],
            }
        }))
    }, [])

    return (
        <div className="bg-white">
            <div className="h-full flex flex-col">
                <form onSubmit={refineSearchFilter} onReset={onResetClick} className="min-h-full w-full flex flex-col">
                    <main className="flex-1 w-full py-4 overflow-y-auto">
                        <div className="flex flex-col md:grid md:grid-cols-8 gap-2 md:gap-4 h-full">
                            {/* Left column - Section Headers */}
                            <div className="flex flex-row md:flex-col gap-1 md:gap-2 border-b md:border-b-0 md:border-r border-gray-300 pb-2 md:pb-0 md:pr-4 md:max-w-[320px] md:col-span-2 items-baseline md:items-stretch overflow-x-auto flex-wrap md:flex-nowrap">

                                {/* Keyword Search Section */}
                                <div 
                                    className={`cursor-pointer p-2 md:p-3 rounded-lg transition-colors flex-shrink-0 whitespace-nowrap min-w-fit ${
                                        activeFilterSection === 'keyword' ? 'bg-[#BC8B20] text-white' : 'hover:bg-gray-100'
                                    }`}
                                    onClick={() => setActiveFilterSection(activeFilterSection === 'keyword' ? null : 'keyword')}
                                >
                                    <div className="flex items-center justify-between">
                                        <div className="flex items-center gap-1 md:gap-2">
                                            <span className="text-xs md:text-base font-medium">Keyword Search</span>
                                            {getKeywordFiltersCount() > 0 && (
                                                <span className={`text-xs rounded-full px-1 md:px-2 py-0.5 md:py-1 min-w-[18px] md:min-w-[20px] text-center ${activeFilterSection === 'keyword' ? 'bg-white text-[#bc8b20]' : 'bg-[#bc8b20] text-white'}`}>
                                                    {getKeywordFiltersCount()}
                                                </span>
                                            )}
                                        </div>
                                        {activeFilterSection === 'keyword' ? <IoMdArrowDropdown /> : <IoMdArrowDropright />}
                                    </div>
                                </div>

                                {/* Deal Section */}
                                <div 
                                    className={`cursor-pointer p-2 md:p-3 rounded-lg transition-colors flex-shrink-0 whitespace-nowrap min-w-fit ${
                                        activeFilterSection === 'deal' ? 'bg-[#BC8B20] text-white' : 'hover:bg-gray-100'
                                    }`}
                                    onClick={() => setActiveFilterSection(activeFilterSection === 'deal' ? null : 'deal')}
                                >
                                    <div className="flex items-center justify-between">
                                        <div className="flex items-center gap-1 md:gap-2">
                                            <span className="text-xs md:text-base font-medium">Deal</span>
                                            {getDealFiltersCount() > 0 && (
                                                <span className={`text-xs rounded-full px-1 md:px-2 py-0.5 md:py-1 min-w-[18px] md:min-w-[20px] text-center ${activeFilterSection === 'deal' ? 'bg-white text-[#bc8b20]' : 'bg-[#bc8b20] text-white'}`}>
                                                    {getDealFiltersCount()}
                                                </span>
                                            )}
                                        </div>
                                        {activeFilterSection === 'deal' ? <IoMdArrowDropdown /> : <IoMdArrowDropright />}
                                    </div>
                                </div>

                                {/* Company Section */}
                                <div 
                                    className={`cursor-pointer p-2 md:p-3 rounded-lg transition-colors flex-shrink-0 whitespace-nowrap min-w-fit ${
                                        activeFilterSection === 'target' ? 'bg-[#BC8B20] text-white' : 'hover:bg-gray-100'
                                    }`}
                                    onClick={() => setActiveFilterSection(activeFilterSection === 'target' ? null : 'target')}
                                >
                                    <div className="flex items-center justify-between">
                                        <div className="flex items-center gap-1 md:gap-2">
                                            <span className="text-xs md:text-base font-medium">Company</span>
                                            {getTargetFiltersCount() > 0 && (
                                                <span className={`text-xs rounded-full px-1 md:px-2 py-0.5 md:py-1 min-w-[18px] md:min-w-[20px] text-center ${activeFilterSection === 'target' ? 'bg-white text-[#bc8b20]' : 'bg-[#bc8b20] text-white'}`}>
                                                    {getTargetFiltersCount()}
                                                </span>
                                            )}
                                        </div>
                                        {activeFilterSection === 'target' ? <IoMdArrowDropdown /> : <IoMdArrowDropright />}
                                    </div>
                                </div>

                            </div>
                            
                            {/* Right column - Filter Content */}
                            <div className="overflow-visible mt-4 md:mt-0 pb-20 md:pb-0 md:col-span-6">
                                {/* Company Section Content */}
                                <div className={`grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-8 gap-y-4 ${activeFilterSection === 'target' ? '' : 'hidden'}`}>
                                    <RegionFilter
                                        RegionOptions={RegionOptions}
                                        setRegionOptions={setRegionOptions}
                                        customPathname={generalPathname}
                                        onChange={onRegionChange}
                                        isPopupOpen={openFilterPopup === 'region'}
                                        setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'region' : null)}
                                    />
                                    <CityFilter
                                        CityOptions={CityOptions}
                                        setCityOptions={setCityOptions}
                                        customPathname={generalPathname}
                                        isPopupOpen={openFilterPopup === 'city'}
                                        setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'city' : null)}
                                    />
                                    <TypeFilter
                                        TypeOption={TypeOption}
                                        setTypeOption={setTypeOption}
                                        customPathname={generalPathname}
                                        dataPath="re_exits"
                                        accordionClick={() => accordionClick(31)}
                                        open={select === 31} 
                                    />
                                </div>

                                {/* Deal Section Content */}
                                <div className={`grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-8 gap-y-4 ${activeFilterSection === 'deal' ? '' : 'hidden'}`}>
                                    <AcquirerDealRangeFilter
                                        MaxDealOptions={MaxDealRangeOptions}
                                        setMaxDealOptions={setMaxDealRangeOptions}
                                        MinDealOptions={MinDealRangeOptions}
                                        setMinDealOptions={setMinDealRangeOptions}
                                        MaxDealrange={ReCompaniesMaxDealOptions}
                                        MinDealRange={ReCompaniesMinDealOptions}
                                        label="Deal Range (US $M)"
                                        customPathname={generalPathname}
                                        isPopupOpen={openFilterPopup === 'dealRange'}
                                        setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'dealRange' : null)}
                                    />
                                    <Subsectors
                                        options={SubSectorOptions}
                                        setOptions={setSubSectorOptions}
                                        customPathname={generalPathname}
                                        label="Subsector"
                                    />
                                </div>

                                {/* Keyword Search Section Content */}
                                <div className={`w-full md:w-1/2 ${activeFilterSection === 'keyword' ? '' : 'hidden'}`}>
                                    <div className="space-y-4">
                                        <Acquirers 
                                            options={AcquirersOptions}
                                            setOptions={setAcquirersOptions}
                                            customPathname={customPathname}
                                            label="Acquirers"
                                        />

                                        <TargetCompany 
                                            options={TargetCompanyOptions}
                                            setOptions={setTargetCompanyOptions}
                                            customPathname={customPathname}
                                            label="Company"
                                            menu={menu}
                                        />

                                        <LAdvisor 
                                            options={lAdvisorsOptions}
                                            setOptions={setlAdvisorsOptions}
                                            customPathname={customPathname}
                                            label="Legal Advisors"
                                            menu={menu}
                                        />

                                        <TAdvisor 
                                            options={tAdvisorsOptions}
                                            setOptions={settAdvisorsOptions}
                                            label="Transaction Advisors"
                                            customPathname={customPathname}
                                            menu={menu}
                                        />
                                    </div>
                                </div>

                                {/* No section selected */}
                                {!activeFilterSection && (
                                    <div className="flex items-center justify-center h-40 text-gray-500">
                                        <p>Select a filter category from the left to view available filters</p>
                                    </div>
                                )}
                            </div>
                        </div>
                    </main>
                </form>
            </div>
        </div>
    );
}

